import {
  DateRangePicker,
  DateRangePickerProps,
  DateRange,
} from "@mui/x-date-pickers-pro";

export type { DateRangePickerProps, DateRange };
export default DateRangePicker;
